import React from 'react';
import { setDash } from '../../../../../lib/common';
import InfoTable from '../../../../../components/table/InfoTable';
import './BrandDetailOrderBalanceCount.scss';

const BrandDetailOrderBalanceCount = (props) => {
  const { countInfo } = props;
  const {
    paymentDoneCount,
    deliveryReadyCount,
    deliveryIngCount,
    deliveryDoneCount,
    orderConfirmCount,
    cancelCount,
    returnCount,
    changeCount,
  } = countInfo;

  return (
    <div className="brand-detail-order-balance-count-content">
      {/* 주문 정보 */}
      <div className="brand-detail-order-balance-count-section">
        <div className="title">주문 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc" colSpan={2}>
                결제완료
              </td>
              <td className="tc" colSpan={2}>
                {setDash(paymentDoneCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                상품 준비
              </td>
              <td className="tc" colSpan={2}>
                {setDash(deliveryReadyCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                배송중
              </td>
              <td className="tc" colSpan={2}>
                {setDash(deliveryIngCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                배송완료
              </td>
              <td className="tc" colSpan={2}>
                {setDash(deliveryDoneCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                구매확정
              </td>
              <td className="tc" colSpan={2}>
                {setDash(orderConfirmCount)}
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>

      {/* 취소/반품/교환 정보 */}
      <div className="brand-detail-order-balance-count-section">
        <div className="title">취소/반품/교환 정보</div>

        <InfoTable>
          <tbody>
            <tr>
              <td className="label tc" colSpan={2}>
                취소요청
              </td>
              <td className="tc" colSpan={2}>
                {setDash(cancelCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                반품요청
              </td>
              <td className="tc" colSpan={2}>
                {setDash(returnCount)}
              </td>
            </tr>
            <tr>
              <td className="label tc" colSpan={2}>
                교환요청
              </td>
              <td className="tc" colSpan={2}>
                {setDash(changeCount)}
              </td>
            </tr>
          </tbody>
        </InfoTable>
      </div>
    </div>
  );
};

export default BrandDetailOrderBalanceCount;
